<template>
  <div>
    <div class="header">
      <div class="buttons">
          <el-button type="primary" @click="isOpenNewStorybook = true" size="mini" icon="el-icon-plus" round>New Storybook</el-button>
          <el-button type="primary" @click="isOpenCopyStorybook = true" size="mini" round>Copy Storybook</el-button>
      </div>
    </div>
    <Table :items="storybooks" :columns="columns" :actions="actions" filterProp="name" :loading="loading.storybooks" />
    <Dialog title="Create Storybook" :show="isOpenNewStorybook" :onClose="() => isOpenNewStorybook = false">
      <el-form :model="item" label-width="190px" label-position="left" size="small" width="275px"
        style="margin-top: 32px;">
        <el-form-item label="Team Storybook Token" required>
          <el-input v-model="item.token" />
        </el-form-item>
        <el-form-item label="Storybook URL" required>
          <el-input v-model="item.storybook_url" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSync(item)">Sync</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
    <Dialog title="Copy Storybook" :show="isOpenCopyStorybook"  :onClose="() => isOpenCopyStorybook = false">
      <el-form :model="item" label-width="190px" label-position="left" size="small" width="275px"
        style="margin-top: 32px;">
        <el-form-item label="From team id" required>
          <el-input v-model="copyDialogData.fromTeamId" />
        </el-form-item>
        <el-form-item label="To team id" required>
          <el-input v-model="copyDialogData.toTeamId" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleCopy(item)">Copy</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import Table from "@/components/Table";
import api from "@/utils/api";
import { baseApiClient as unauthedApiClient } from "@/utils/api";
import { mapGetters, mapActions } from "vuex";
import { deserializeDate, timeSince } from "@/utils/time";
import Dialog from '@/components/Dialog';
export default {
  components: {
    Table,
    Dialog
  },
  mounted() {
    this.getStorybooks();
  },
  data() {
    return {
      isOpenNewStorybook: false,
      isOpenCopyStorybook: false,
      columns: [
        { label: "Storybook ID", prop: "id" },
        {
          label: "Last sync",
          formatter: (props) =>
            `${timeSince(deserializeDate(props.created_at))} ago`,
        },
        { label: "Team ID", prop: "team" },
        { label: "Team name", prop: "team_name" },
      ],
      actions: [
        { name: "Sync", type: "primary", onClick: this.handleSyncFromTable },
        { name: "Open", type: "secondary", onClick: this.handleOpenStorybook },
      ],
      item: { token: null, storybook_url: null },
      copyDialogData: { fromTeamId: null, toTeamId: null },
    };
  },
  computed: mapGetters(["storybooks", "loading"]),
  methods: {
    ...mapActions(["getStorybooks"]),
    async handleSyncFromTable(item) {
      await unauthedApiClient.put(
        `/services/s2f/storybook/${item.id}`,
        {
          is_from_admin: true,
          upload_status: "complete",
          preload_stories: true,
        },
        {
          headers: {
            Authorization: `Bearer ${item.storybook_token}`,
          },
        }
      );

      this.$message.success(`Triggered sync successfully`);
    },
    handleOpenStorybook(item) {
      window.open(item.storybook_preview_url + '/index.html', "_blank");
    },
    async handleCopy() {
      const { fromTeamId, toTeamId } = this.copyDialogData;
      if (!fromTeamId) {
        return this.$message.error("Please fill from team id");
      }
      if (!toTeamId) {
        return this.$message.error("Please fill to team id");
      }
      await api.post(
        `/services/s2f/rpc/copy_storybook`,
        {
          from_team_id: fromTeamId,
          to_team_id: toTeamId,
        }
      );

      this.$message.success(`Triggered copy successfully`);
      this.isOpenCopyStorybook = false;
    },
    async handleSync(item) {
      try {
        const { storybook_url, token } = item;

        if (!token) {
          return this.$message.error("Please fill token");
        }
        if (!storybook_url) {
          return this.$message.error("Please fill storybook_url");
        }

        await unauthedApiClient.get(`/services/s2f/validate_token`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        let storybookId = null;
        try {
          const res = await unauthedApiClient.get(
            `/services/s2f/storybook?storybook_preview_url=${storybook_url}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          storybookId = res.data.id;
          await unauthedApiClient.put(
            `/services/s2f/storybook/${storybookId}`,
            {
              upload_status: "complete",
              preload_stories: true,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } catch (e) {
          if (e.response.status === 404) {
            const res = await unauthedApiClient.post(
              "/services/s2f/storybook",
              {
                storybook_preview_url: storybook_url,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            storybookId = res.data.id;
          } else {
            return this.$message.error(e.response.statusText);
          }
        }

        this.$message.success(`Triggered sync successfully`);
      } catch (e) {
        this.$notify.error({
          title: "Failed syncing",
          message: e.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 10px 0;
}

.between-label {
    margin: 0 8px;
}

.buttons {
    display: flex;
    align-items: center;
}

.buttons > * {
    margin-right: 5px;
}

h4 {
    margin-right: 10px;
}
</style>

